var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechSpecsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4959 17.4138C12.1019 16.3178 10.6909 12.6388 10.1059 11.1168C9.00295 11.8538 7.77195 12.5518 6.59395 13.0448C6.22795 14.3248 5.49995 16.7538 5.14795 17.0778C4.54395 17.6348 4.31595 17.5628 4.22295 16.7988C4.12995 16.0348 3.73795 13.5628 3.73795 13.5628C3.73795 13.5628 1.57595 12.3438 0.89795 11.9948C0.21995 11.6458 0.23095 11.4038 0.95495 11.0208C1.37695 10.7978 3.88195 10.9358 5.19695 11.0258C6.05795 10.0748 7.12795 9.14383 8.18995 8.34683C6.97495 7.27083 4.03995 4.67183 3.15595 3.92283C2.37995 3.26483 3.23495 3.12583 3.23495 3.12583C3.62495 3.05583 4.45695 2.99383 4.86295 3.11683C7.38695 3.87983 11.3049 5.18483 12.2259 5.49283L13.3879 4.67183C18.0899 1.34183 19.275 2.07883 19.499 2.40183C19.723 2.72483 20.0019 4.10283 15.2999 7.43383L14.1399 8.25683C14.1109 9.23683 13.983 13.4078 13.8289 16.0678C13.804 16.4958 13.4619 17.2658 13.2639 17.6118C13.2629 17.6118 12.841 18.3768 12.4959 17.4138Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSpecsIcon);
export default __webpack_public_path__ + "static/media/tech_specs_icon.f0d76ce64f5cb9edad0cd2c36252f178.svg";
export { ForwardRef as ReactComponent };